import React from 'react';
import dayjs from 'dayjs';
import classes from './ExpenseMobileCard.module.scss';
import { generalEnums } from '../../../../../utils/enums';

export default function ExpenseMobileCard(props) {
  const { info, isApprover } = props;

  return (
    <div className={classes.container}>
      <div className={isApprover ? classes.columnApprover : classes.column}>
        {isApprover ? (
          <>
            <p className={classes.date}>{dayjs(info.CreatedDate).format(generalEnums.DATEWITH_MMM)}</p>
            <p className={classes.comment}>{info.ClaimDescription}</p>
            <p className={classes.name}>
              {info.User.FirstName} {info.User.LastName}
            </p>
          </>
        ) : (
          <>
            <p className={classes.comment}>{info.ClaimDescription}</p>
            <p className={classes.date}>{dayjs(info.CreatedDate).format(generalEnums.DATEWITH_MMM)}</p>
          </>
        )}
      </div>
      <div className={classes.column}>
        <p className={classes.amount}>
          {info.ExpenseCurrency?.Symbol} {info.TotalExpense}
        </p>
      </div>
    </div>
  );
}
